import { isDesktopPlatform } from '@/lib/desktop/bridge';
import { isNativePlatform } from '@/lib/mobile/platform';

/**
 * Whether the current shell forbids a plaintext TanStack Query cache in
 * `localStorage`.
 *
 * True for the desktop renderer and for the native WKWebView. Neither stores
 * `localStorage` in a browser profile the user can inspect or clear: on iOS it
 * is an unencrypted file inside the app container, readable from a filesystem
 * backup or an unlocked device long after the session it belongs to. The cache
 * is a default-allow denylist held for a 24h `maxAge`, so anything a new query
 * root forgets to exclude lands there by default — the wrong default for
 * constituent data. Both shells keep a native session and a long-lived
 * renderer, so the cache buys them nothing a refetch does not.
 *
 * Kept out of `query-persistence.ts` so that module imports nothing but query-key
 * roots, and never reaches for platform detection or the desktop bridge. What it
 * exports is a pure predicate over a query key, testable without stubbing a
 * platform; that property is worth one extra file.
 */
export function isPlaintextCacheDisallowed(): boolean {
  return isDesktopPlatform() || isNativePlatform();
}
